import {HandlerList} from "../../../infrastructure/handlers/handler-list";
import {PredictionsWidgetFetchHandler} from "./predictions-widget.fetch-handler";
import {TimingHandler} from "../../../infrastructure/handlers/timing-handler";
import {PredictionsWidgetMarketNavigationClickEventHandler} from "./predictions-widget.market-navigation-click-event.handler";
import {PostPredictionHandler} from "../../../core/handlers/post-prediction-handler";
import {PredictionClickEventHandler} from "../../../core/handlers/prediction-click-event.handler";
import {PredictionShowEventHandler} from "../../../core/handlers/prediction.show-event.handler"
import {PredictionWidgetTabChangeHandler} from "./prediction-widget.tab-change.handler";
import {PropositionBetsPopupDisplayHandler} from "../../../core/handlers/proposition-bets.popup-display.handler";
import {PredictionWidgetTabClickEventHandler} from "./prediction-widget.tab-click.event.handler";
import {PredictionWidgetPopulateDataHandler} from "./prediction-widget.populate-data.handler";

export class PredictionsWidgetHandlers extends HandlerList {

  static injectables = [
    PredictionsWidgetFetchHandler,
    PredictionsWidgetMarketNavigationClickEventHandler,
    PostPredictionHandler,
    PredictionClickEventHandler,
    PredictionShowEventHandler,
    PredictionWidgetTabChangeHandler,
    PropositionBetsPopupDisplayHandler,
    PredictionWidgetTabClickEventHandler,
    PredictionWidgetPopulateDataHandler,
    TimingHandler
  ];

  constructor(
    predictionWidgetFetchHandler: PredictionsWidgetFetchHandler,
    predictionsWidgetMarketNavigationClickEventHandler: PredictionsWidgetMarketNavigationClickEventHandler,
    postPredictionHandler: PostPredictionHandler,
    predictionClickEventHandler: PredictionClickEventHandler,
    predictionShowEventHandler:PredictionShowEventHandler,
    predictionWidgetTabChangeHandler: PredictionWidgetTabChangeHandler,
    predictionPropositionBetsPopupDisplayHandler: PropositionBetsPopupDisplayHandler,
    predictionWidgetTabClickEventHandler: PredictionWidgetTabClickEventHandler,
    predictionWidgetPopulateDataHandler: PredictionWidgetPopulateDataHandler,
    timingHandler: TimingHandler
  ) {
    super();

    [
      predictionWidgetFetchHandler,
      predictionsWidgetMarketNavigationClickEventHandler,
      postPredictionHandler,
      predictionClickEventHandler,
      predictionShowEventHandler,
      predictionWidgetTabChangeHandler,
      predictionPropositionBetsPopupDisplayHandler,
      predictionWidgetTabClickEventHandler,
      predictionWidgetPopulateDataHandler,
      timingHandler
    ].forEach(x => this.add(x));
  }
}
